import { connect } from 'react-redux';
import { getViewedProductGroup } from '../../../../../store/associations/selectors';
import GroupModal from './GroupModal';
import { setOpenModal } from '../../../../../store/modals/actions';
import { getModals } from '../../../../../store/modals/selectors';
import { setErrorMessage } from '../../../../../store/associations/actions';

const mapStateToProps = (state) => ({
  modals: getModals(state),
  viewedProductGroup: getViewedProductGroup(state),
});

const mapDispatchToProps = (dispatch) => ({
  setOpenModal: (modal, value) => {
    dispatch(setOpenModal(modal, value));
  },

  setErrorMessage: (errorMessage) => {
    dispatch(setErrorMessage(errorMessage));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupModal);
